import { useEffect } from 'react';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const GA4_ID = (process.env.REACT_APP_GA4_ID || '').trim();
const SCRIPT_ID = 'rwm-ga4-script';
const CONFIG_ID = 'rwm-ga4-config';

function injectGA4(measurementId) {
  if (!measurementId || document.getElementById(SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  const inline = document.createElement('script');
  inline.id = CONFIG_ID;
  inline.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${measurementId}');
  `;
  document.head.appendChild(inline);
}

export default function GA4Manager() {
  const { analytics, ready } = useCookieConsent();

  useEffect(() => {
    if (!ready || !GA4_ID) return;
    if (analytics === true) {
      injectGA4(GA4_ID);
    }
  }, [analytics, ready]);

  return null;
}
